export default "__VITE_ASSET__f035f518__"